import { render, staticRenderFns } from "./PostProductionStaff.vue?vue&type=template&id=dc703b74&"
import script from "./PostProductionStaff.vue?vue&type=script&lang=js&"
export * from "./PostProductionStaff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports